<template>
  <div class="pie">
    <v-charts :option="option" style="width:100%;height:100%"></v-charts>
  </div>
</template>

<script>
export default {
  name: 'pie',
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      option: {
        color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
        tooltip: {
          show: false
        },
        legend: {
          show: false,
          orient: 'vertical',
          left: 'right',
          top: 'middle',
          icon: 'rect',
          itemHeight: 14,
          itemWidth: 14,
          align: 'left',
          formatter: function (json) {
            const { sort, percentage } = JSON.parse(json)
            return `${sort}: ${percentage}`
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            data: [],
            label: {
              show: false
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  },
  watch: {

  },
  computed: {

  },
  methods: {

  },
  mounted() {
    this.option.series[0].name = this.item.tbQuestionnaireName
    this.option.series[0].data = this.item.answers.map((i, index1) => {
      return {
        value: i.percentage,
        name: JSON.stringify({ sort: index1 + 1, percentage: i.percentage + '%' })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.pie {
  vertical-align: top;
  display: inline-block;
  width: 300px;
  height: 300px;
}
</style>